import { ValidationError } from 'class-validator';
import { i18n } from '@/translations';
import { camelCase } from 'lodash';
export var isValidationError = function (err) {
    var _a, _b;
    var hasValidationErrors = Array.isArray(err) && err[0] instanceof ValidationError;
    if (!hasValidationErrors && ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors)) {
        hasValidationErrors = true;
    }
    return hasValidationErrors;
};
/**
 * Map validation errors to form errors for the UI
 *
 * @param errors The validation errors array
 */
export var mapValidationErrors = function (errors) {
    var _a, _b;
    var formErrors = {};
    if (errors[0] instanceof ValidationError) {
        errors.map(function (error) {
            formErrors[error.property] = Object.keys(error.constraints || {}).map(function (constraint) { return i18n.tc("validation." + constraint).toString(); });
        });
    }
    else {
        var serverErrors_1 = (_b = (_a = errors.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors;
        if (Object.keys(serverErrors_1).length) {
            Object.keys(serverErrors_1).forEach(function (key) {
                formErrors[camelCase(key)] = serverErrors_1[key];
            });
        }
    }
    return formErrors;
};
export var getCSRFToken = function () {
    var _a;
    return (_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content');
};
export var readFile = function (file) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (e) {
            var _a;
            if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.result) {
                resolve(e.target.result.toString());
            }
        };
        reader.readAsDataURL(file);
    });
};
